import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';
import { AdvisorCompany } from '../models/advisor-company.model';

export interface UpdateAdvisorCompanyTextArg {
    id: string;
    wiringInstructions: string | null;
    footerText: string | null;
}

export const UpdateAdvisorCompanyText = createAsyncThunk(
    'advisorCompanies/updateText',
    async (arg: UpdateAdvisorCompanyTextArg, dispatch: any) => {
        const axios = dispatch.getState().core.axios;

        const response = await axios.put(
            `api/marketplace/advisor-companies/${arg.id}/text`,
            {
                wiringInstructions: arg.wiringInstructions,
                footerText: arg.footerText,
            }
        );

        if (response.status !== 200) {
            const message =
                response?.response?.data?.title ??
                response?.response?.data?.detail ??
                'An error occurred while saving the advisor company.';
            createNotification(message, 'error');
            throw new Error('Failed to update advisor company');
        }

        createNotification('Advisor company saved.', 'success');
        return response.data as AdvisorCompany;
    }
);
